import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter, NavLink } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import Modal from 'react-bootstrap/Modal';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Nav from 'react-bootstrap/Nav';
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
import Dropdown from 'react-bootstrap/Dropdown';
import ListGroup from 'react-bootstrap/ListGroup';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import axios from 'axios';
import {
    FaExternalLinkAlt, FaAndroid, FaApple, FaCog, FaPlus,
} from 'react-icons/fa';
import { FiExternalLink } from 'react-icons/fi';
import AppsDrawer from '@appblocks/frontend/client/Components/AppsDrawer';
import LoginButton from '@appblocks/frontend/client/Components/LoginButton';

const store = require('@appblocks/frontend/redux/store').default;

const mapStateToProps = state => state;

const DEFAULT_WORKSPACE_NAME = 'Default Workspace';

class WorkspaceView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showCreateWorkspace: false,
            workspaceName: '',
            showSwitchWorkspace: false,
        };

        this.createWorkspace = this.createWorkspace.bind(this);
        this.toggleSwitchWorkspace = this.toggleSwitchWorkspace.bind(this);
        this.getWorkspace = this.getWorkspace.bind(this);
    }

    setWorkspace(workspaceId) {
        this.setState({
            showSwitchWorkspace: false,
        });
        store.dispatch({
            type: 'workspaces/setCurrentWorkspace',
            payload: workspaceId,
        });
        this.props.history.push('/');
    }

    getWorkspace(workspaceId) {
        const workspace = this.props.workspaces.workspaces.find(w => w._id === workspaceId);
        if (workspace) {
            return workspace;
        }
        return '';
    }

    toggleSwitchWorkspace() {
        const { showSwitchWorkspace } = this.state;
        this.setState({
            showSwitchWorkspace: !showSwitchWorkspace,
        });
    }

    createWorkspace(e) {
        e.preventDefault();
        const { workspaceName } = this.state;
        axios.post(`${process.env.API_URL}/api/workspaces`, {
            name: workspaceName,
        })
            .then((response) => {
                this.setState({ showCreateWorkspace: false });
                store.dispatch({
                    type: 'workspaces/getWorkspaces',
                });
                this.setWorkspace(response.data._id);
            })
            .catch((ex) => {
                console.log(ex);
            });
    }

    render() {
        const currentWorkspace = this.getWorkspace(this.props.workspaces.currentWorkspace);
        return (
            <>
                <Nav>
                    <Dropdown align="end" className="ms-1 justify-content-end">
                        <Dropdown.Toggle variant="link" className="">
                            {this.props.workspaces.currentWorkspace ? (
                                currentWorkspace.name
                            ) : DEFAULT_WORKSPACE_NAME}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {(currentWorkspace
                                && currentWorkspace.owner === this.props.user.user.id)
                                && (
                                    <Dropdown.Item
                                        as={Link}
                                        to="/settings/workspace"
                                    >
                                        <FaCog className="me-1" />
                                        Workspace Settings
                                    </Dropdown.Item>
                                )}
                            <Dropdown.Item
                                onClick={this.toggleSwitchWorkspace}
                            >
                                <FaExternalLinkAlt className="me-1" />
                                Switch Workspace
                            </Dropdown.Item>
                            <Dropdown.Item onClick={async () => {
                                this.setState({
                                    showCreateWorkspace: true,
                                    workspaceName: '',
                                });
                            }}
                            >
                                <FaPlus className="me-1" />
                                Create Workspace
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Nav>
                <Modal
                    show={this.state.showCreateWorkspace}
                    onHide={() => this.setState({ showCreateWorkspace: false })}
                >
                    <form onSubmit={this.createWorkspace}>
                        <Modal.Header closeButton>
                            <Modal.Title>
                                <span>Create Workspace</span>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Workspace Name"
                                value={this.state.workspaceName}
                                onChange={e => this.setState({ workspaceName: e.target.value })}
                            />
                        </Modal.Body>
                        <Modal.Footer>
                            <Button type="submit" variant="primary">
                                Create
                            </Button>
                            <Button variant="secondary" onClick={() => this.setState({ showCreateWorkspace: false })}>
                                Cancel
                            </Button>
                        </Modal.Footer>
                    </form>
                </Modal>
                <Modal
                    show={this.state.showSwitchWorkspace}
                    onHide={() => this.setState({ showSwitchWorkspace: false })}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <span>Switch Workspace</span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ListGroup>
                            <ListGroup.Item
                                onClick={() => {
                                    this.setWorkspace('');
                                }}
                                action
                            >
                                {DEFAULT_WORKSPACE_NAME}
                            </ListGroup.Item>
                            {this.props.workspaces.workspaces.map(workspace => (
                                <ListGroup.Item
                                    key={workspace._id}
                                    onClick={() => {
                                        this.setWorkspace(workspace._id);
                                    }}
                                    action
                                >
                                    {workspace.name}
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ showSwitchWorkspace: false })}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default connect(mapStateToProps, {})(
    Object.assign(withRouter(WorkspaceView), { contextType: undefined }),
);
